import api from '../../../../core/apiclient'
import actionTypes from '../../../../core/constants/action-types'

export default {
    [actionTypes.CONFIGURACAO.PARAMETROS.BUSCAR_TODOS_PARAMETROS]: async ({commit}) => {
        const {data} = await api.parametros.buscarTodosParametros()
        commit('SET_PARAMETROS', data)
    }
}
